import { Link, useParams } from "react-router-dom";
import { resources } from "../Resources";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import { Typography } from "@mui/material";

export function BottomNavigator() {
	const params = useParams();
	const resourceSlug = params.resourceSlug;

	const index = resources.findIndex(
		(resource) => resource.slug === resourceSlug,
	);

	return (
		<div className="bottom-navigation-container">
			<div className="item-container">
				{index > 0 && (
					<Link
						to={`/resources/${resources[index - 1].slug}`}
						className="black-text no-underline-link left">
						<div className="navigation-icon-container">
							<FaArrowLeft className="normal-icon" />
							<Typography className="normal-text">Previous</Typography>
						</div>
						<Typography className="normal-text yellow-text">
							{resources[index - 1].title}
						</Typography>
					</Link>
				)}
			</div>
			<div className="item-container">
				{index < resources.length - 1 && (
					<Link
						to={`/resources/${resources[index + 1].slug}`}
						className="black-text no-underline-link right">
						<div className="navigation-icon-container">
							<Typography className="normal-text">Next</Typography>
							<FaArrowRight className="normal-icon" />
						</div>
						<Typography className="normal-text yellow-text">
							{resources[index + 1].title}
						</Typography>
					</Link>
				)}
			</div>
		</div>
	);
}
